// src/ar/objectDetection.ts
var OBJECT_DETECTOR_ASSETS_BASE_URL = "/face";
var OBJECT_DETECTOR_MODEL_FILE = "efficientdet_lite0.tflite";
var OBJECT_DETECTOR_WASM_PATH = `${OBJECT_DETECTOR_ASSETS_BASE_URL}/wasm`;
var OBJECT_DETECTOR_MODEL_PATH = `${OBJECT_DETECTOR_ASSETS_BASE_URL}/${OBJECT_DETECTOR_MODEL_FILE}`;
var OBJECT_DETECTOR_DEFAULT_SCORE_THRESHOLD = 0.2;
var OBJECT_DETECTOR_DEFAULT_MAX_RESULTS = 8;
var loadObjectDetector = (options) => import("./objectDetector-VZJTH2FS.mjs").then((m) => m.createObjectDetector(options));
var toDetections = (result, minScore = 0) => {
  const out = [];
  for (const det of result.detections) {
    const category = det.categories[0];
    const box = det.boundingBox;
    if (!category || !box) continue;
    if (!Number.isFinite(category.score) || category.score < minScore) continue;
    out.push({
      label: category.categoryName,
      score: category.score,
      box: {
        x: box.originX,
        y: box.originY,
        width: box.width,
        height: box.height
      }
    });
  }
  out.sort((a, b) => b.score - a.score);
  return out;
};
var bestDetectionFor = (detections, label, minScore) => {
  let best = null;
  for (const det of detections) {
    if (det.label !== label || det.score < minScore) continue;
    if (!best || det.score > best.score) best = det;
  }
  return best;
};
var labelsSeen = (detections, exclude, minScore, limit = 5) => {
  const best = /* @__PURE__ */ new Map();
  for (const det of detections) {
    if (det.label === exclude || det.score < minScore) continue;
    const prev = best.get(det.label);
    if (prev === void 0 || det.score > prev) best.set(det.label, det.score);
  }
  return [...best.entries()].map(([label, score]) => ({ label, score })).sort((a, b) => b.score - a.score).slice(0, limit);
};
var coverTransform = (source, view) => {
  if (!(source.width > 0) || !(source.height > 0) || !(view.width > 0) || !(view.height > 0)) {
    return { scale: 1, offsetX: 0, offsetY: 0 };
  }
  const scale = Math.max(
    view.width / source.width,
    view.height / source.height
  );
  return {
    scale,
    offsetX: (view.width - source.width * scale) / 2,
    offsetY: (view.height - source.height * scale) / 2
  };
};
var boxToView = (box, transform) => ({
  x: box.x * transform.scale + transform.offsetX,
  y: box.y * transform.scale + transform.offsetY,
  width: box.width * transform.scale,
  height: box.height * transform.scale
});

export {
  OBJECT_DETECTOR_ASSETS_BASE_URL,
  OBJECT_DETECTOR_MODEL_FILE,
  OBJECT_DETECTOR_WASM_PATH,
  OBJECT_DETECTOR_MODEL_PATH,
  OBJECT_DETECTOR_DEFAULT_SCORE_THRESHOLD,
  OBJECT_DETECTOR_DEFAULT_MAX_RESULTS,
  loadObjectDetector,
  toDetections,
  bestDetectionFor,
  labelsSeen,
  coverTransform,
  boxToView
};
//# sourceMappingURL=chunk-U3YN5RIT.mjs.map